import { ICompaniesContext, useCompaniesContext } from "../../context"

export const useCompanies: () => ICompaniesContext = () => {
  const context = useCompaniesContext()
  return context
}
